import { PageTitleAtom } from '@projtech-package/react-components/lib';
import { useAtom } from 'jotai';
import { useNavigate } from 'react-router-dom';

export function useProjtechNavigate() {
	const [pageTitle, setPageTitle] = useAtom(PageTitleAtom);
	const redirect = new URLSearchParams(window.location.search).get('redirect');
	const routes = useNavigate();

	const router = (to: string | number, routerName?: string) => {
		if (typeof to === 'string' && to.startsWith('http')) {
			window.open(to, '_blank');
			return;
		}

		setPageTitle(routerName || '');

		if (to === -1) {
			routes(-1);
		}

		const url = typeof to === 'string' ? to : '';

		const hasRedirectInUrl = url?.includes('redirect=');

		if (hasRedirectInUrl || !redirect || redirect.replace('redirect=', '')?.length > 1) {
			routes(url);
			return;
		}

		const separator = url.includes('?') ? '&' : '?';

		routes(`${url}${separator}redirect=${encodeURIComponent(redirect)}`);
	};

	return { router, pageTitle, redirect };
}
